import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import { VTextField } from 'vuetify/lib';
import pt from "vuetify/es5/locale/pt";

import 'vuetify/dist/vuetify.min.css';

Vue.use(
  Vuetify, 
  { components: { VTextField } }
);

export default new Vuetify({
  theme: {
    dark: false,

    themes: {
      light: {
        primary: "#10403B",
        secondary: "#127369",
        botao_1: "#127369",
        botao_2: "#4C5958",
        background: "#F1F1F1",
        footer: "#10403B",
      },

      dark: {
        primary: "#027333",
        secondary: "#04D939",
        botao_1: "#04D939",
        botao_2: "#4C5958",
        background: "#012340",
        footer: "#027333",
      }
    }
  },
  lang: {
    locales: { pt },
    current: "pt"
  },
});
